<script>
  /**
   * @typedef {Object} SelectOption
   * @property {string} name
   * @property {string| number} value
   */
  /**
   * @type {SelectOption[]}
   */
  export let options = [];
  export let placeholder = undefined;
  // If there is no placeholder, we set the value to the first option
  export let value = placeholder
    ? placeholder
    : options.length
      ? options[0].value
      : "";

  export let isInvalid = false;
  export let description = undefined;
  export let id = "";
  export let variant = "primary";
  export let small = false;
  export let disable = false;
  export let label = "";
  export let required = false;

  const removePreviousErrors = () => {
    if (isInvalid) {
      description = "";
    }
    isInvalid = false; // reset isInvalid when the user clicks on the form element
  };

  let isShaking = false;
  function shake() {
    isShaking = true;
    setTimeout(() => {
      isShaking = false;
    }, 500);
  }

  // Reactivity
  $: if (isInvalid && !isShaking) {
    shake();
  }
</script>

<div>
  <label for={id}>{label}{required ? "*" : ""}</label>
  <select
    {id}
    on:click={removePreviousErrors}
    on:click
    bind:value
    on:change
    on:contextmenu
    on:input
    class:invalid={isInvalid}
    class:shaking={isShaking}
    class:select-orange={variant === "orange"}
    class:small
    disabled={disable}
    class:disable
  >
    {#if placeholder}
      <option value={placeholder} disabled selected hidden>{placeholder}</option
      >
    {/if}
    {#each options as { name, value }}
      <option {value}>{name}</option>
    {/each}
  </select>
  {#if description}
    <p class="description">{description}</p>
  {/if}
</div>

<style>
  select {
    outline: none; /* Remove the default focus outline */
    display: block;
    border: solid var(--bw) var(--border-color);
    border-radius: var(--br);
    min-width: 11rem;
    width: 100%;
    padding: 0.5rem 0.9rem;
    background-color: var(--pax-white);
    color: var(--pax-black);
    cursor: pointer;

    /* arrowIcon */
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    background-image: url("/icons/caret-down.svg");
    background-repeat: no-repeat;
    background-position: right 0.5rem center;
    background-size: 1rem;
    padding-right: 1rem;
  }

  select option {
    background-color: var(--pax-white);
    color: var(--pax-black);
  }

  .select-orange {
    background-color: var(--pax-orange);
    color: var(--pax-white);
    border-radius: 1rem;
    padding: 0 1rem;
    align-items: center;
    justify-content: center;
    height: 2rem;
    width: auto;
    border: none;
    min-width: fit-content !important;
    background-image: url("/icons/caret-down-white.svg");
    padding-right: 1.75rem;
  }

  select.invalid {
    border: solid var(--bw) var(--pax-danger);
  }

  p {
    font-size: var(--s);
    font-weight: 200;
    text-align: left;
    color: var(--pax-black);
    margin-top: 0.5rem;
    padding-left: var(--xs);
  }

  .small {
    background-size: 0.75rem;
    height: 1.75rem;
    background-position-y: 0.75rem;
    padding-left: 0.75rem;
  }

  .disable {
    opacity: 50%;
    background-color: var(--pax-black);
    color: var(--pax-white);
    cursor: not-allowed;
  }

  label {
    display: block;
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
    font-weight: 700;
    color: #1f2937;
  }
</style>
